// extracted by mini-css-extract-plugin
module.exports = {"toggleShowAll":"tasteNotes__toggleShowAll--10uVv","whatPeopleTalkAbout":"tasteNotes__whatPeopleTalkAbout--26Gxi"};